import React, { Fragment } from 'react';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import { GatsbyImage } from 'gatsby-plugin-image'

import {
  BannerWrapper,
  BannerParagraphContainer,
  BannerHeadingContainer,
  ImageWrapper,
  LinearGradient
} from './banner.about.styles';
import BannerAboutConfetti from './banner.about.confetti'
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import { graphql, useStaticQuery } from 'gatsby'
import useOnMobile from 'src/hooks/useOnMobile';

interface BannerAboutProps {
  title: string;
  description: string;
}

const BannerLanding = (props: BannerAboutProps): JSX.Element => {
  const isMobile = useOnMobile();

  const images: any = useStaticQuery(graphql`{
    hero: contentfulAsset(contentful_id: {eq: "3pH2lrfsbluW6OKRKat2RM"}) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    }
    heroMobile: contentfulAsset(contentful_id: {eq: "4boG8AK6e6u4NK9HkAQA1a"}) {
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
    }
  }
  `)

  return (
    <Fragment>
      <BannerWrapper>
        <BannerAboutConfetti />
        <BannerHeadingContainer>
          <FadeInAnimationWrapper>
            <Heading
              text={props.title}
              size="3.25em"
              sizeSubLg="2em"
              sizeSm="1.8rem"
              align="center"
            />
          </FadeInAnimationWrapper>
        </BannerHeadingContainer>
        <BannerParagraphContainer>
          <Paragraph
            text={props.description}
            size="1.5em"
            sizeSm="1.25em"
            weight="light"
            align="center"
          />
        </BannerParagraphContainer>
      </BannerWrapper>
      <ImageWrapper>
        <LinearGradient />
        {
          !isMobile ? (
            <GatsbyImage
              image={images.hero.gatsbyImageData}
              alt="Mighty Networks"
            />
          ) : (
            <GatsbyImage
              image={images.heroMobile.gatsbyImageData}
              alt="Mighty Networks"
            />
          )
        }
      </ImageWrapper>
    </Fragment>
  )
}

export default BannerLanding;
